import React, { Fragment } from 'react';

import styles from './ACRoundBoxWithDotLayout.module.scss';

export default class ACRoundBoxWithDotLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      layoutStyle = {},
      classNameOuter = '',
      classNameDot = '',
      showDot = false,
    } = this.props;

    const {
      borderStyle = 'none',
      borderWidth = '1px',
      borderColor = 'none',
      borderRadius = '',
      backgroundColor = 'transparent',
      dotColor = 'transparent',
    } = layoutStyle;

    let classNamesOuter = [styles.outer, classNameOuter];

    let classNamesDot = [styles.dot, classNameDot];

    return (
      <Fragment>
        <div
          className={classNamesOuter.join(' ')}
          style={{
            borderStyle,
            borderWidth,
            borderColor,
            borderRadius,
            backgroundColor,
          }}
        >
          {showDot === true ? (
            <span
              className={classNamesDot.join(' ')}
              style={{
                backgroundColor: dotColor,
              }}
            />
          ) : null}
          {this.props.children}
        </div>
      </Fragment>
    );
  }
}
